import { Row, Col } from "antd";
import { Route, Switch } from "react-router-dom";
import useViewport from "components/UseViewport/UseViewport";
import KdImage from "assets/images/headerImage/KD_cover_image_2022.jpg";
import AboutKD from "./AboutKD/AboutKD";
import PartnersPage from "./PartnersPage/PartnersPage";
import HeaderImage from "./HeaderImage/HeaderImage";
import NavMenu from "./NavMenu/NavMenu";
import Members from "./Members/Members";

const KDAboutUs = () => {
  const { width } = useViewport();
  const breakpoint = 992;

  return (
    <>
      <HeaderImage imageLink={KdImage} alt="Karrieredagene members" />
      <Row gutter={[0, 48]} wrap style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "90px" }}>
        <Col lg={6} sm={24} xs={24}>
          {/* TODO maybe add affix to navbar so it moves down only on the white */}
          <NavMenu />
        </Col>
        <Col lg={18} sm={24} style={{ paddingLeft: width >= breakpoint ? "5em" : "0%" }}>
          <Switch>
            <Route path="/kd/about-us/members/" component={Members} />
            <Route path="/kd/about-us/partners/" component={PartnersPage} />
            <Route path="/kd/about-us/" component={AboutKD} />
          </Switch>
        </Col>
      </Row>
    </>
  );
};

export default KDAboutUs;
